import { TAG_NAME_RUN } from '@videotools/js/api/entities/TagButton';
import transHelpers from '../util/transHelpers';

export default {
	methods: {
		getAthleteRunSubtags(runTag, sourceTags) {
			const endTimestamp = runTag.endTimestamp;
			const startTimestamp = runTag.startTimestamp;

			// get the sub tags that fit inside the interval
			const subtags = sourceTags.filter(evTag => {
				return evTag.name !== TAG_NAME_RUN &&
					evTag.timestamp >= startTimestamp &&
					evTag.timestamp < endTimestamp &&
					evTag.player?.id === runTag.player?.id;
			});

			// order subtags by timestamp ASC
			subtags.sort((a, b) => a.timestamp <= b.timestamp ? -1 : 1);
			return subtags;
		},
		generateSingleAthleteRunTagNames(runTags) {
			const sortedTags = [...runTags].sort((a, b) => a.startTimestamp < b.startTimestamp ? -1 : 1);
			return sortedTags.reduce((acc, t, idx) => {
				return { ...acc, [t.id]: `${transHelpers.transUcfirst('one.run')} ${idx + 1}` };
			}, {});
		},
		generateAllAthleteRunTagNames(sourceTags) {
			const runTags = this.getAthleteRunTags(sourceTags);
			// get all unique athleteIds
			const athleteIds = [...new Set(runTags.map(evTag => evTag.playerId))];
			let ret = {};
			for (const athleteId of athleteIds) {
				const athleteRunTags = runTags.filter(evTag => evTag.playerId === athleteId);
				ret = { ...ret, ...this.generateSingleAthleteRunTagNames(athleteRunTags) };
			}

			return ret;
		},
		getAthleteRunTags(athleteTags) {
			return athleteTags
				.filter(eventTag => eventTag.name === TAG_NAME_RUN);
		},
	},
};
